(function ($) {
  window.dbcom = window.dbcom || {}

  /**
  * Helper function that properly applies parameters to a url and then returns
  * the update url string.
  *
  * @param path {string}
  * @param params {object} query params to apply to path.
  *
  * @returns {string}
  */
  function formatUrl(path, params) {
    params = params || {}

    const url = new Url(path)

    if (params && Object.keys(params).length > 0) {
      url.clearQuery()

      // Add in each param
      for (const key in params) {
        url.query[key] = params[key]
      }
    }

    return url.decode(url.toString())
  }

  dbcom.fetch = function (url, params, onSuccess, onFail) {
    const path = formatUrl(url, params)

    debug.data('GET', path)
    debug.performanceStart(path)
    $.getJSON(path)
      .done((data) => {
        debug.performanceEnd(path)
        debug.data('SUCCESS', data)

        if (typeof onSuccess === 'function') {
          onSuccess(data)
        }
      })
      .fail((data) => {
        console.error(data)
        debug.data('ERROR', data)

        if (typeof onFail === 'function') {
          onFail(data)
        }
      })
  }
}(jQuery))
